import React from 'react';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      message: '',
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: error?.message || 'Unexpected application error',
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App crashed:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.assign('/');
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="app-error-shell" role="alert" aria-live="assertive">
        <div className="app-error-card">
          <p className="app-error-kicker">Something went wrong</p>
          <h1>We hit a temporary issue</h1>
          <p className="app-error-message">{this.state.message}</p>
          <div className="app-error-actions">
            <button type="button" onClick={this.handleReload}>
              Reload page
            </button>
            <button type="button" className="secondary" onClick={this.handleHome}>
              Back to home
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
